module.exports = __webpack_public_path__ + "img/chongqing.2ae761dd.png";